upload:
  filePickerBrowseLabel: Or browse files...

pdf:
  upload:
    dropLabel: Drag & drop PDF here
    invalidType: PDFs only
csv:
  upload:
    dropLabel: Drag & drop CSV here
    invalidType: CSVs only
